import { format } from 'date-fns'

export const domainUrl = 'https://payment.da-ai.org.my/' //'https://payment.da-ai.org.my/' //'https://pay.geotech.solutions/' payment.da-ai.org.my
//payment.da-ai.org.my
export const payDomain = 'https://pay.da-ai.org.my/' //'https://pay.geotech.solutions/' // http://pay.infinityss.com.my/   localhost:65387
export const storeDomain = 'https://catalog.da-ai.org.my/' // 'https://catalog.pkthkm.org.my/' //https://catalog.da-ai.org.my/'
export const receiptUrl = payDomain + 'receipt'

export const convertToDate = (date) => {
  //console.log(date)
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
  const _date = new Date(Date.parse(date))

  const year = _date.getFullYear()
  const month = String(_date.getMonth() + 1).padStart(2, '0')
  const day = String(_date.getDate()).padStart(2, '0')
  return `${year}/${month}/${day}`
  return _date.toLocaleDateString('en-GB', options)
}

export const convertToDate2 = (date) => {
  //console.log(date)
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
  const _date = new Date(Date.parse(date))

  const year = _date.getFullYear()
  const month = String(_date.getMonth() + 1).padStart(2, '0')
  const day = String(_date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
  return _date.toLocaleDateString('en-GB', options)
}

export const convertToTime2 = (date) => {
  //console.log(date)
  var options = { hour12: false }
  const _date = new Date(Date.parse(date))
  return _date.toLocaleTimeString('en-US', options)
}

export const convertToTime3 = (date) => {
  const _date = new Date(Date.parse(date))
  var options = { hour12: false }
  //let hours = _date.getHours()

  const timeString = format(date, 'HH:mm')
  const hours = _date.getHours().toString().padStart(2, '0')
  const minutes = _date.getMinutes().toString().padStart(2, '0')
  const seconds = _date.getSeconds().toString().padStart(2, '0') // Format hours to show 6:00:00 for 6 AM and 18:00:00 for 6 PM
  /*
  if (hours < 10) {
    hours = hours.toString()
  }
*/
  console.log('timeString', timeString)
  return timeString
  return `${hours}:${minutes}:${seconds}`
}
export const convertToTime = (date) => {
  const _date = new Date(Date.parse(date))
  var options = { hour12: false }
  //let hours = _date.getHours()

  const timeString = format(date, 'HH:mm:ss')
  const timeStringWithAMPM = format(date, 'hh:mm:ss a')
  const hours = _date.getHours().toString().padStart(2, '0')
  const minutes = _date.getMinutes().toString().padStart(2, '0')
  const seconds = _date.getSeconds().toString().padStart(2, '0') // Format hours to show 6:00:00 for 6 AM and 18:00:00 for 6 PM
  /*
  if (hours < 10) {
    hours = hours.toString()
  }
*/
  //console.log(timeString)
  return timeString
  return `${hours}:${minutes}:${seconds}`
}

// src/graphql/queries/paymentLink.js

export const GET_PAYMENT_LINKS_PAGED = `
  query GetPaymentLinksPaged(
    $sessionToken: String!
    $page: Int
    $pageSize: Int
    $sortBy: String
    $sortOrder: String
  ) {
    getpaymentlink(
      sessionToken: $sessionToken
      page: $page
      pageSize: $pageSize
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      items {
        signature
        status
        datetime_created
        datetime_modified
        payment_url
        input_url
        amount
        donor_email
        donor_contact
        donor_name
        receipt_email
        events
        remark
        group
        storeOrdId
        shortened_url_input
        shortened_url_payment
        salesperson
        bank
        transactionRef
        orderId
      }
      totalCount
      page
      pageSize
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`
